export default __webpack_public_path__ + "static/media/image-gallery-orange.373d43f1.jpg";